import { useState } from 'react'
import type { FormEvent } from 'react'
import './CreateLeagueScreen.css'

interface JoinLeagueScreenProps {
  onJoin: (inviteCode: string) => Promise<void> | void
  onCancel: () => void
}

function JoinLeagueScreen({ onJoin, onCancel }: JoinLeagueScreenProps) {
  const [code, setCode] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    const trimmed = code.trim()

    if (!trimmed) {
      setError('Invite code is required.')
      return
    }

    setError(null)
    setIsSubmitting(true)
    try {
      await onJoin(trimmed)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <form className="create-league" onSubmit={handleSubmit}>
      <p className="create-league__title">Join a league</p>
      <input
        className="create-league__input"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        placeholder="Invite code"
        autoFocus
      />
      {error && <p className="create-league__error">{error}</p>}
      <div className="create-league__actions">
        <button type="button" className="create-league__cancel" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="create-league__submit" disabled={isSubmitting}>
          {isSubmitting ? 'Joining…' : 'Join'}
        </button>
      </div>
    </form>
  )
}

export default JoinLeagueScreen
